import { SearchableItem } from './interface/searchable.item';
import { SearchableSelectionType } from './interface/searchable.selection';
import { SystemType } from './enums/system.type';

/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export class Preference implements SearchableItem {
  ID: string;
  NAME: string;
  SORT: boolean;
  ORDER: string;
  STATE: string;
  STAGE: string;
  ASSIGNEE: string;
  PROCESSOR: string;
  RESEARCH_ANALYST: string;
  FINANCIAL_ANALYST: string;
  SENIOR_ANALYST: string;
  BANK: string;
  DELAYED_TYPE: string;
  SIZE: number;
  SELECTED: boolean;
  TAGS: string;
  SLIDER_VALUE: number;
  TYPE: SystemType;
  EQUIPMENT_PROCESSOR: string;
  EQUIPMENT_RESEARCH_ANALYST: string;
  EQUIPMENT_APPRAISER: string;
  EQUIPMENT_REVIEWER: string;
  MISC: string;

  // Helpers
  active = false;
  allowed = false;

  static parse(json: any): Preference {
    if (json) {
      const f = new Preference();

      f.ID = json.ID;
      f.SORT = Boolean(json.SORT);
      f.NAME = json.NAME;
      f.ORDER = json.ORDER;
      f.STATE = json.STATE;
      f.STAGE = json.STAGE;
      f.ASSIGNEE = json.ASSIGNEE;
      f.PROCESSOR = json.PROCESSOR;
      f.RESEARCH_ANALYST = json.RESEARCH_ANALYST;
      f.FINANCIAL_ANALYST = json.FINANCIAL_ANALYST;
      f.SENIOR_ANALYST = json.SENIOR_ANALYST;
      f.BANK = json.BANK;
      f.SELECTED = Boolean(json.SELECTED);
      f.DELAYED_TYPE = json.DELAYED_TYPE;
      f.SIZE = json.SIZE;
      f.TAGS = json.TAGS;
      f.SLIDER_VALUE = json.SLIDER_VALUE;
      f.TYPE = SystemType[<string>json.TYPE];

      f.EQUIPMENT_PROCESSOR = json.EQUIPMENT_PROCESSOR;
      f.EQUIPMENT_RESEARCH_ANALYST = json.EQUIPMENT_RESEARCH_ANALYST;
      f.EQUIPMENT_APPRAISER = json.EQUIPMENT_APPRAISER;
      f.EQUIPMENT_REVIEWER = json.EQUIPMENT_REVIEWER;
      f.MISC = json.MISC;

      return f;
    } else return null;
  }

  static parseArray(json: any[]): Preference[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Preference.parse(j));

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
